import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ykdyk3bm3: FaireProductEntity = {
  token: "p_7ykdyk3bm3",
  type: "product",
  name: "Lavender Essential Oil | Therapeutic Grade | Aromatherapy",
  brandToken: "b_v59f599x2t",
  brandName: "Plant of Life",
  imageUrl:
    "https://cdn.faire.com/fastly/d6d42e4409e93581d868782c8c258639fa52d2b35946f13bd0624588801fff62.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c2b8a0414170d0821ad4bc3930b7ac92d944c7e760476bd72c4b511d1f200f1.jpeg",
    "https://cdn.faire.com/fastly/8e209818df260abcdc5cdd915bcd541dd2b04b40fbfb33c7539e7d03b325d32f.jpeg",
    "https://cdn.faire.com/fastly/db41d2f92b2b75349f3fb9faa2761c0d114805aeaf520a58d02a5b26a7341c78.jpeg",
    "https://cdn.faire.com/fastly/18a2435454cad45618185709535b7ddece19dd8f7813b9d57a62376cc77487cd.jpeg",
    "https://cdn.faire.com/fastly/7af7b095b3cb580382fd7bc25792b9762c69d95346257874a39592b49bd16f70.jpeg",
    "https://cdn.faire.com/fastly/1fbc888a1a99fb073fdf167e37ab56751a8e5964b4669a07a95c8d854c805237.jpeg",
  ],
  priceDollars: 8.99,
  description:
    "Experience the soothing and enchanting aroma of Lavender in its purest form. Our Lavender Essential Oil is carefully crafted to provide you with a therapeutic-grade oil that promotes relaxation, calmness, and a myriad of other wellness benefits.\n\nCalming Aromatherapy: Immerse yourself in the gentle and soothing scent of pure Lavender Essential Oil. Let its calming aroma envelop your senses, easing stress, and promoting tranquility.\n\nTherapeutic-Grade Quality: Our Lavender Essential Oil is sourced from the finest lavender plants, and it undergoes meticulous testing to ensure it meets the highest standards of purity and potency.\n\nVersatile Benefits: Discover the versatility of Lavender Essential Oil. Use it for aromatherapy, massage, DIY skincare, or in diffusers to create a serene ambiance in your living spaces.\n",
  tags: [],
  msrpDollars: 17.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:40.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
